module.exports = __webpack_public_path__ + "static/colgadas-005-8347e15af14032611c4ffbcc80938174.jpg";